import FPW from '@svelte/forgot_password.component.svelte'
import '@scss/app.scss'

import '~/bootstrap/dist/js/bootstrap.bundle'
import $ from '~/jquery'

window.jQuery = $
window.$ = $

const passwordComponent = new FPW({
    target: document.getElementById('app'),
    props: {
        isEndato: (document.querySelector('input[name="wl"]')).value === '64'
        , app: (document.querySelector('input[name="app"]'))?.value
    }
})

export default passwordComponent